module.exports = __webpack_public_path__ + "c450cb2ea15afe5057ec4454c07ae5b4.svg";